import { render, staticRenderFns } from "./handPaper.vue?vue&type=template&id=456e9e16&scoped=true"
import script from "./handPaper.vue?vue&type=script&lang=js"
export * from "./handPaper.vue?vue&type=script&lang=js"
import style0 from "./handPaper.vue?vue&type=style&index=0&id=456e9e16&prod&lang=stylus&scoped=true"
import style1 from "./handPaper.vue?vue&type=style&index=1&id=456e9e16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e9e16",
  null
  
)

export default component.exports